import ActionManager from '../ActionManager';

import OpenDoc from './OpenDoc';
ActionManager.register(OpenDoc, ['stores:MainStore']);

